import { Company } from './state/form-state-provider';

/**
 * Returns a value indicating whether the specified value is an empty string.
 */
export const isEmptyField = (value: string) => value.trim() === '';

/**
 * Returns a value indicating whether the specified country should use VAT number or organization
 * number. Currently only Sweden uses organization number. All other countries use VAT number.
 */
export const vatNumberOrOrgNumber = (countryCode: Company['countryCode']) =>
  countryCode === 'SE' ? 'orgNumber' : 'vatNumber';
